module.exports = __webpack_public_path__ + "img/waving_penis.55a7ffec.gif";